import { storyStore } from '@story/mixins/storyStore';

export const reviewStore = {
    state: {
        reviewPartner: null,
        reviewPartners: null,
    },
    setReviewPartners(reviewPartners) {
        this.state.reviewPartners = reviewPartners;
        // emit event to global event bus
        !storyStore.state.storybookMode &&
            window.Vue.default.prototype.$eventHub.$emit(
                'update-review-dropdown'
            );
    },
};
